<form nz-form style="padding-top:12px;padding-right:12px"   autocomplete="off">
  
  <div class="relative">
    <nz-table
      [nzShowTotal]="rangeTemplate"
      [nzFrontPagination]="false"
      #Table nzOuterBordered nzShowSizeChanger [nzData]="dataList" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)" [nzShowTotal]="rangeTemplate">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft>STT</th>
          <th  nzLeft>Tên</th> 
          <th nzRight nzWidth="60px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{ data.fullName }}</td> 
          <td nzRight>
            <div nz-space nzAlign="end" class="space-align-block"> 
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div> 
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
  <div *nzModalFooter> 
    <div class="card-footer text-right">
        <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndClose]="false" (close)="close()">Đóng</popup-btn-footer>
    </div>
  </div>
</form>